"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ISerializedComponentFunctionAssignmentSchema = exports.ISerializedExternalComponentAssignmentSchema = exports.ISerializedTraversalSchema = void 0;
exports.createSerializedTraversalSchema = createSerializedTraversalSchema;
const zod_1 = require("zod");
const FunctionalAddressing_1 = require("./FunctionalAddressing");
const IComponentFunctionSignalAssignment_1 = require("./IComponentFunctionSignalAssignment");
function createSerializedTraversalSchema(metadataSchema) {
    return zod_1.z.object({
        path: zod_1.z.string(),
        metadata: zod_1.z.record(zod_1.z.coerce.number(), metadataSchema ?? zod_1.z.object({}).passthrough()).optional(),
    });
}
exports.ISerializedTraversalSchema = createSerializedTraversalSchema();
exports.ISerializedExternalComponentAssignmentSchema = zod_1.z.object({
    assignment: zod_1.z.string(),
    traversals: zod_1.z.array(exports.ISerializedTraversalSchema),
});
exports.ISerializedComponentFunctionAssignmentSchema = zod_1.z.lazy(() => zod_1.z.object({
    function: zod_1.z.string(),
    functionClass: zod_1.z.string().optional(),
    isUnassigned: zod_1.z.boolean().optional(),
    signalAssignments: zod_1.z.record(zod_1.z.string(), IComponentFunctionSignalAssignment_1.IComponentFunctionSignalAssignmentSchema.array()),
    externalComponentAssignments: zod_1.z.record(zod_1.z.string(), zod_1.z.record(zod_1.z.string(), exports.ISerializedExternalComponentAssignmentSchema.array())),
    addressableComponents: FunctionalAddressing_1.ControllerBusAddressSchema.array().optional(),
    externalConnectionAssignments: zod_1.z.record(zod_1.z.string(), zod_1.z.string()),
    childBusAssignments: zod_1.z
        .record(zod_1.z.string(), zod_1.z.lazy(() => exports.ISerializedComponentFunctionAssignmentSchema))
        .optional(),
}));
//# sourceMappingURL=ISerializedTraversal.js.map